import { type ReactNode } from "react";
import classNames from "classnames";

export const CellWithSubtitle = (props: {
  className?: string;
  title: ReactNode;
  subtitle?: ReactNode;
  lightHeader?: boolean;
}) => (
  <div className={classNames("scha__order-table__header", props.className)}>
    {!!props.title && (
      <div
        className={classNames("scha__order-table__header__title", {
          "scha__order-table__header__title--light": props.lightHeader,
        })}
      >
        {props.title}
      </div>
    )}
    {props.subtitle && <div className="scha__order-table__header__subtitle">{props.subtitle}</div>}
  </div>
);
